import { GameState } from '../../types/state';

export const IsTeamLocked = (state: GameState, teamCode?: string) => {
  return state?.teams?.find((x) => x.code === teamCode)?.isLocked;
};
